import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const TextColumn = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled.div`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    line-height: 100%;
    text-transform: uppercase;
  }
`;

export const StyledHeadlineEntityLink = styled(EntityLink)`
  ${clickableFrameLinkStyles}
  color: #000000;
`;

export const Container = styled.div`
  ${clickableFrameStyles(StyledHeadlineEntityLink)}
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;

  ${theme.breakpoints.only("tablet")} {
    flex-flow: column nowrap;
  }
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 18px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.36px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    letter-spacing: -0.32px;
  }
`;

export const ActionBar = styled.div`
  time {
    color: #727272;
    font-size: 11px;
  }
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  display: block;

  inline-size: 100px;
`;

export const CoverImage = styled.div`
  inline-size: 100px;
  block-size: 100px;
`;
